import { Badge, Chip } from '@galaxy-react/core';

import styled from '@emotion/styled';

const ChipsWrapperStyled = styled('div')({
  display: 'flex',
  marginTop: '8px',
  height: 'min-content',
  gap: '8px',
});

type ChipContent = {
  label: string;
  color: string;
};

export type DocumentTypeDetailsChipsProps = {
  labels?: ChipContent[];
};

export const DocumentTypeDetailsChips = ({ labels = [] }: DocumentTypeDetailsChipsProps) => {
  return (
    <ChipsWrapperStyled>
      {labels && labels.length > 1
        ? labels?.slice(0, 4).map((item) => <Chip key={item.label} color={item.color} label={item.label} />)
        : labels?.map((item) => <Chip key={item.label} color={item.color} label={item.label} />)}

      {labels && labels.length > 4 ? <Badge variant="overflow" count={labels.length - 4} /> : null}
    </ChipsWrapperStyled>
  );
};

export default DocumentTypeDetailsChips;
